import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
type TInitialState = {
    dateRange: any,
    deviceFilter: undefined | string,
    clientName: undefined | string,
    clientIdString: undefined | string,
    employeeId: undefined | string,
    departmentId: undefined | string,
    departmentName: undefined | string,
    designationName: undefined | string,
    positionId: undefined | string,
    pageNumber: number,
    pageSize: number,
    month: any,
    singleDate: any,
    isSingleDate: boolean,
    isSingleDateForEmpDet: boolean,
    searchValue: any,
    topValue: any,
    permissionSetValue: undefined | string
    projectStatus: undefined | string
    projectDateRange: any,
    timeRange?: any,
    projectName: undefined | string,
    projectId: undefined | string,
    milestoneName: undefined | string,
    milestoneId: undefined | string,
    taskName: undefined | string,
    taskId: undefined | string,
}
export const filteringInitialState: TInitialState = {
    timeRange: [dayjs().hour(9).minute(0).second(0), dayjs().hour(18).minute(0).second(0)],
    projectDateRange: [null, null],
    dateRange: [dayjs().subtract(1, 'week'), dayjs()],
    deviceFilter: undefined,
    clientName: undefined,
    clientIdString: undefined,
    employeeId: undefined,
    departmentId: undefined,
    departmentName: undefined,
    designationName: undefined,
    positionId: undefined,
    pageNumber: 1,
    pageSize: 20,
    month: dayjs(),
    singleDate: dayjs(),
    isSingleDate: false,
    isSingleDateForEmpDet: true,
    searchValue: undefined,
    topValue: 10,
    permissionSetValue: undefined,
    projectStatus: undefined,
    projectName: undefined,
    projectId: undefined,
    milestoneName: undefined,
    milestoneId: undefined,
    taskName: undefined,
    taskId: undefined,
}
const filteringSlice = createSlice({
    name: "filtering",
    initialState: filteringInitialState,
    reducers: {
        setFilterData: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
    }
})

export const { setFilterData } = filteringSlice.actions;
export default filteringSlice.reducer;
export const filterData = (state: any) => state?.filter;